import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import CategoryForm from '../../../components/SiteAdmin/CategoryForm/CategoryForm';
import s from './AddTopFeature.css';

export class AddTopFeature extends Component {

    render() {
        return (
            <div className={s.root}>
                <div className={s.container}>
                    <div className={s.paddingRoutesSection}>
                        <CategoryForm />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({})
const mapDispatchToProps = {}

export default compose(
    injectIntl,
    withStyles(s),
    connect(mapStateToProps, mapDispatchToProps)
)(AddTopFeature)
